export const HEADER_TITLE_SX = {
  fontSize: "1.4rem",
  fontWeight: 800,
  color: "#648315",
  textAlign: { xs: "center", md: "left" },
};
